/*
 * @Author: 时不待我 790002517@qq.com
 * @Date: 2023-04-17 11:57:29
 * @LastEditors: 时不待我 790002517@qq.com
 * @LastEditTime: 2023-04-17 12:04:38
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: '/contentgrid',
    routes: [
      // your routes definition here
    ]
  })
  
  export default router


// WEBPACK FOOTER //
// ./src/router/index.js